module.exports = __webpack_public_path__ + "14b77c60433a9e43fdb2a00ec7f8e393.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-52@2x.png
// module id = 523
// module chunks = 0